import 'plyr/dist/plyr.css';
import { setupVideoModalTriggers } from '../../../helpers/video-modal';

document.addEventListener('DOMContentLoaded', () => {
    // Initialize video modal triggers for the provider page
    setupVideoModalTriggers('.provider-video-trigger', 'videoModal');
});
